import { Toaster } from '@ifixit/ui/components/toast';
import { _js } from '@ifixit/utils/localize';
import { createTrackedRoot } from 'Shared/react-mount-tracker';
import { showStashedSuccessToast } from 'Shared/reload_with_toast';

// The one Toaster a page's toasts land in: a page that mounts its own draws
// every toast twice, and no header hosts this on a nanosite or in the app.
const container = document.createElement('div');
document.body.append(container);

createTrackedRoot(container).render(
   <Toaster
      position="bottom-right"
      closeLabel={_js('Close')}
      regionLabel={_js('Notifications (F8)')}
   />
);

showStashedSuccessToast();
